export const CLIENT_ROUTE = '/color';
export const API_ROUTE = '/api/color';
export const CLIENT_TITLE = 'Playlist-н өнгө';